import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
interface MetricBadgeProps {
  content: string;
  metadata?: {
    label?: string;
    value?: string;
    trend?: 'up' | 'down' | 'neutral';
  };
}
export function MetricBadge({
  content,
  metadata
}: MetricBadgeProps) {
  const [label, value] = content.split(':').map(s => s.trim());
  const displayLabel = metadata?.label || label;
  const displayValue = metadata?.value || value;
  const getTrendIcon = () => {
    if (metadata?.trend === 'up') return <TrendingUpIcon className="w-4 h-4 text-green-400" data-id="element-346" />;
    if (metadata?.trend === 'down') return <TrendingDownIcon className="w-4 h-4 text-red-400" data-id="element-347" />;
    return <MinusIcon className="w-4 h-4 text-slate-400" data-id="element-348" />;
  };
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.2
  }} className="inline-flex items-center gap-3 bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 rounded-lg px-4 py-3 shadow-lg" data-id="element-349">
      <div className="flex-1" data-id="element-350">
        <p className="text-xs text-slate-400 mb-0.5" data-id="element-351">{displayLabel}</p>
        <p className="text-xl font-semibold text-white" data-id="element-352">{displayValue}</p>
      </div>
      {metadata?.trend && <div className="flex-shrink-0" data-id="element-353">{getTrendIcon()}</div>}
    </motion.div>;
}